"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BI_VIDEO_TYPE = exports.BI_ORIGIN = void 0;
var BI_ORIGIN;
(function (BI_ORIGIN) {
    BI_ORIGIN["ON_SITE"] = "on_site";
})(BI_ORIGIN = exports.BI_ORIGIN || (exports.BI_ORIGIN = {}));
var BI_VIDEO_TYPE;
(function (BI_VIDEO_TYPE) {
    BI_VIDEO_TYPE["LIVE"] = "live";
    BI_VIDEO_TYPE["SCHEDULED"] = "scheduled";
})(BI_VIDEO_TYPE = exports.BI_VIDEO_TYPE || (exports.BI_VIDEO_TYPE = {}));
//# sourceMappingURL=bi.js.map